import React, {Component} from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import Button from '@spothero/ui/button';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import FormGroup from '@spothero/ui/form-group';
import Label from '@spothero/ui/label';
import TextInput from '@spothero/ui/text-input';
import EnvironmentUtils from '@spothero/utils/environment';
import ValidationUtils from '@spothero/utils/validation';
import UserAPI from 'api/user';
import UserUtils from 'user/user-utils';

export default class CustomerLookup extends Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired
    };
    state = {
        isLoading: false,
        error: null
    };

    _onChange = () => {
        this.setState({
            error: null
        });
    }

    _onInvalid = () => {
        this.setState({
            error: <FormElementError>Please enter a valid email.</FormElementError>
        });
    }

    _onSubmit = evt => {
        const {
            email
        } = serialize(evt.target, {hash: true});

        this._submitForm(email);
    }

    async _submitForm(email) {
        const {
            onSubmit
        } = this.props;

        if (email) {
            this.setState({
                isLoading: true
            });

            try {
                const {
                    data: {
                        data
                    }
                } = await UserAPI.lookup(email);

                onSubmit({
                    user: {
                        ...data,
                        status: UserUtils.AUTH_STATE.USER
                    },
                    newUser: false,
                    error: false
                });
            } catch (error) {
                onSubmit({
                    user: {
                        status: UserUtils.AUTH_STATE.USER,
                        email,
                        id: false,
                        referralToken: false,
                        credit: 0,
                        creditCards: [],
                        licensePlates: []
                    },
                    newUser: true,
                    error: (error.status !== 404)
                });
            }

            this.setState({
                isLoading: false
            });
        }
    }

    render() {
        const {
            isLoading,
            error
        } = this.state;

        return (
            <Form
                id="CustomerLookup-form"
                className="CustomerLookup"
                onSubmit={this._onSubmit}
            >
                <FormGroup inline>
                    <TextInput
                        name="email"
                        type="email"
                        label={<Label>Customer Email</Label>}
                        placeholder={(EnvironmentUtils.isMobileDevice()) ? 'Customer Email' : ''}
                        pattern={ValidationUtils.EMAIL}
                        onChange={this._onChange}
                        onInvalid={this._onInvalid}
                        autoFocus
                        required
                    />
                    <Button
                        type="submit"
                        color="primary"
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        Find or Create
                    </Button>
                </FormGroup>
                {error}
            </Form>
        );
    }
}
